/* eslint-disable no-bitwise */
import {deburr, toLower, trim} from 'lodash';
import {isNullOrUndefined} from 'common/util/HelperUtil';

export class StringUtil {
    // alternative https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
    public static escapeRegExp(str: string): string {
        if (typeof str !== 'string') {
            return str;
        }

        return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&'); // and .replace(/-/g, '\\x2d');
    }

    public static hash(str: string, seed: number = 0): string {
        let h1 = 0xdeadbeef ^ seed;
        let h2 = 0x41c6ce57 ^ seed;
        for(let i = 0, ch; i < str.length; i++) {
            ch = str.charCodeAt(i);
            h1 = Math.imul(h1 ^ ch, 2654435761);
            h2 = Math.imul(h2 ^ ch, 1597334677);
        }
        h1  = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
        h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
        h2  = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
        h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);

        return (h2>>>0).toString(16).padStart(8, '0') + (h1>>>0).toString(16).padStart(8, '0');
    }

    public static nullable(str: string): string {
        if (isNullOrUndefined(str)) {
            return null;
        }

        if (typeof str === 'string' && str.length === 0) {
            return null;
        }

        return str;
    }

    public static removeMultiSpaces(data: string) {
        if (typeof data !== 'string') {
            return data;
        }

        return data.replace(/\s{2,}/g, ' ');
    }

    public static removeText(data: string, text: string) {
        if (typeof data !== 'string' || typeof text !== 'string' || text.length === 0) {
            return data;
        }

        try {
            data = data.replace(new RegExp(StringUtil.escapeRegExp(text), 'ig'), '');
            data = data.replace(new RegExp(StringUtil.escapeRegExp(text).replace(new RegExp('\\s', 'g'), '-'), 'ig'), '');
        } catch (_e) {
            // ignore
        }

        return data;
    }

    public static replace(str: string, targets: string[], replacers: string[]): string {
        if (typeof str !== 'string') {
            return str;
        }

        if (targets.length !== replacers.length) {
            return str;
        }

        let output: string = str;
        targets.forEach((target, index) => {
            output = output.replace(new RegExp(StringUtil.escapeRegExp(target), 'ig'), replacers[index]);
        });

        return output;
    }

    public static slugify(raw: string, separator: string = ''): string {
        if (raw === undefined) {
            return '';
        }

        return toLower(trim(deburr(raw)).replace(/[^0-9a-z\-\_]/gi, separator));
    }

    public static truncate(str: string, limit: number): string {
        if (isNullOrUndefined(str) || str.length <= limit) {
            return str;
        }

        if (limit <= 3) {
            return '';
        }

        return str.slice(0, limit - 3) + '...';
    }
}
